<template>
  <div
    class="d-flex justify-center align-center"
  >
    <div class="py-8">
      <v-img
        :alt="imgAlt"
        :src="require(`@/assets/img/${imgSrc}`)"
        :height="imgHeight"
        :width="imgWidth"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',

  data() {
    return {
      imgAlt: 'Imagem ilustrativa para o carregamento dos itens da página.',
      imgSrc: 'loading.gif',
      imgHeight: '57',
      imgWidth: '57',
    };
  },
};
</script>
